<!-- <ng-container > -->
@for (insurer of policyPDFDisclosureNotice; track $index; let i = $index) {
  <div class="pdf-page__component">
    <div class="table-pdf-title">
      <div class="table-pdf-title__left">
        <h5>{{insurer?.header}}</h5>
      </div>
    </div>
    <div class="table-pdf-wrap">
      <table class="table table--pdf">
        <thead>
          <tr>
            <th>{{ insurer?.insurer_name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ul class="data">
                  @if (insurer?.physical) {
                    <li class="data__row">
                      <label class="data__label">Physical Address</label>
                      <div class="data__cell">{{insurer?.physical}}</div>
                    </li>
                  }
                  @if (insurer?.postal) {
                    <li class="data__row">
                      <label class="data__label">Postal Address</label>
                      <div class="data__cell">{{insurer?.postal}}</div>
                    </li>
                  }
                  @if (insurer?.tel) {
                    <li class="data__row">
                      <label class="data__label">Telephone Number</label>
                      <div class="data__cell">{{insurer?.tel}}</div>
                    </li>
                  }
                  @if (insurer?.fax) {
                    <li class="data__row">
                      <label class="data__label">Fax Number</label>
                      <div class="data__cell">{{insurer?.fax}}</div>
                    </li>
                  }
                  @if (insurer?.email) {
                    <li class="data__row">
                      <label class="data__label">Email Address</label>
                      <div class="data__cell">{{insurer?.email}}</div>
                    </li>
                  }
                  @if (insurer?.website) {
                    <li class="data__row">
                      <label class="data__label">Website</label>
                      <div class="data__cell">{{insurer?.website}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_name) {
                    <li class="data__row">
                      <label class="data__label">Compliance Officer</label>
                      <div class="data__cell">{{insurer?.compliance_name}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_tel) {
                    <li class="data__row">
                      <label class="data__label">Compliance Tel</label>
                      <div class="data__cell">{{insurer?.compliance_tel}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_email) {
                    <li class="data__row">
                      <label class="data__label">Compliance Email</label>
                      <div class="data__cell">{{insurer?.compliance_email}}</div>
                    </li>
                  }
                  @if (insurer?.compliance_postal) {
                    <li class="data__row">
                      <label class="data__label">Compliance Postal</label>
                      <div class="data__cell">{{insurer?.compliance_postal}}</div>
                    </li>
                  }
                  @if (insurer?.license_no) {
                    <li class="data__row">
                      <label class="data__label">License Number</label>
                      <div class="data__cell">{{insurer?.license_no}}</div>
                    </li>
                  }
                  @if (insurer?.reg_no) {
                    <li class="data__row">
                      <label class="data__label">Registration Number</label>
                      <div class="data__cell">{{insurer?.reg_no}}</div>
                    </li>
                  }
                  @if (insurer?.vat_no) {
                    <li class="data__row">
                      <label class="data__label">VAT Number</label>
                      <div class="data__cell">{{insurer?.vat_no}}</div>
                    </li>
                  }
              </ul>
            </td>
          </tr>
          @if (insurer?.insurance) {
            <tr class="thead">
              <th>
                Your {{insurer?.insurer_type_name}} has the following insurance in place to protect you:
              </th>
            </tr>
            <tr>
              <td>
                <ul class="data">
                    @for (insuranceValue of insurer?.insuranceParsed; track $index) {
                      <li class="data__row">
                        <label class="data__label">{{insuranceValue?.insurer_disclosure}}</label>
                        <div class="data__cell">{{insuranceValue.dr[0]?.disclosure_value}}</div>
                      </li>
                    }
                </ul>
              </td>
            </tr>
          }
          @if (insurer?.claims) {
            <tr class="thead">
              <th>
                Should you have a claim against your policy, please note the following:
              </th>
            </tr>
            <tr>
              <td>
                @for (claimValue of insurer?.claimsParsed; track $index) {
                  <p [innerHtml]="claimValue?.disclosure_value"></p>
                }
              </td>
            </tr>
          }
          @if (insurer?.complaints) {
            <tr class="thead">
              <th>
                Complaints:
              </th>
            </tr>
            <tr>
              <td>
                <ul class="data">
                    @for (complaintsValue of insurer?.complaintsParsed; track $index) {
                      <li class="data__row">
                        <label class="data__label">{{complaintsValue?.disclosure}}</label>
                        <div class="data__cell">{{complaintsValue?.disclosure_value}}</div>
                      </li>
                    }
                </ul>
              </td>
            </tr>
          }
          @if (insurer?.com_binder_conflict) {
            <tr class="thead">
              <th>
                Disclosure:
              </th>
            </tr>
            <tr>
              <td [innerHtml]="insurer?.com_binder_conflict">
              </td>
            </tr>
          }
          @if (insurer?.binder_disclosure) {
            <tr class="thead">
              <th>
                Binder Disclosure:
              </th>
            </tr>
            <tr>
              <td [innerHtml]="insurer?.binder_disclosure">
              </td>
            </tr>
          }
          @if (insurer?.uma_disclosure) {
            <tr class="thead">
              <th>
                Underwriter Disclosure:
              </th>
            </tr>
            <tr>
              <td [innerHtml]="insurer?.uma_disclosure">
              </td>
            </tr>
          }
          @if (insurer?.conflict_disclosure) {
            <tr class="thead">
              <th>
                Other key conflicts of interest disclosures:
              </th>
            </tr>
            <tr>
              <td>
                <ul class="data">
                    @for (conflictDisclosure of insurer?.conflictDisclosureParsed; track $index) {
                      <li class="data__row">
                        <label class="data__label">{{conflictDisclosure?.insurer_disclosure}}</label>
                        <div class="data__cell">{{conflictDisclosure.dr[0]?.disclosure_value}}</div>
                      </li>
                    }
                </ul>
              </td>
            </tr>
          }
          @if (insurer?.conflict_email) {
            <tr class="thead">
              <th>
                Interest management policy can be obtained from:
              </th>
            </tr>
            <tr>
              <td>
                <ul class="data">
                    <li class="data__row">
                      <label class="data__label">
                        Email Address
                      </label>
                      <div class="data__cell">
                        {{insurer?.conflict_email}}
                      </div>
                    </li>
                </ul>
              </td>
            </tr>
          }
          @if (insurer?.premfee_disclosure) {
            <tr class="thead">
              <th>
                Disclosure of premiums and fees
              </th>
            </tr>
            <tr>
              <td>
                <p>{{insurer?.premfee_disclosure}}</p>
              </td>
            </tr>
          }
          @if (insurer?.additional_disclosure) {
            <tr class="thead">
              <th>
                Additional Disclosure:
              </th>
            </tr>
            <tr>
              <td [innerHtml]="insurer?.additional_disclosure">
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
<!-- </ng-container> -->
